import { inject, Injectable } from '@angular/core';
import { AccountsDataProviderService } from '@app/_shared/data/accounts/accounts-data-provider.service';
import { RESPONSE_TEXTS } from '@core/constants/response-texts';
import { isApiError } from '@core/models/errors/api-error';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, switchMap } from 'rxjs';

import { TopInstitutionsActions } from './top-institutions.actions';

@Injectable()
export class TopInstitutionsEffects {
  private actions$ = inject(Actions);
  private dataProvider = inject(AccountsDataProviderService);
  private toastr = inject(ToastrService);

  loadTopInstitutions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TopInstitutionsActions.loadTopInstitutions),
      // R137. `catchError` used to sit here, as a direct argument of the `actions$` pipe. That
      // catches the error but then completes the stream it was applied to — so the *effect* ended,
      // and every later `loadTopInstitutions` was ignored for the rest of the session. NgRx only
      // resubscribes an effect that errors, not one that completes, so the first failed request
      // switched this feature off silently. Catching inside `switchMap` keeps the effect alive.
      switchMap(() =>
        this.dataProvider.getTopInstitutions().pipe(
          map(({ topInstitutions }) =>
            TopInstitutionsActions.loadTopInstitutionsSuccess({
              topInstitutions,
            })
          ),
          catchError((error: unknown) => {
            console.error(
              'Failed to load top institutions — the institution picker will show no suggestions:',
              error
            );
            // A backend rejection has been toasted by the interceptor already.
            if (!isApiError(error)) {
              this.toastr.error(RESPONSE_TEXTS.APP_ERRORS.REQUEST_ERROR);
            }
            return of(TopInstitutionsActions.loadTopInstitutionsFailure());
          })
        )
      )
    );
  });
}
